module.exports = __webpack_public_path__ + "media/f08.65afd1db.mp4";